<template>
	<div class="niceBox">
		<!-- @touchend="touchEnd(1)" -->
		<div class="xnice" @touchstart="touchStart" @click="touchEnd(1)"
			:style="{ transform: scale ? 'scale(1.15)' : 'scale(1)' }" :class="{ ynice: niceImage }"></div>
		<!-- <div class="tnice7" v-show="isNice">{{ shareNum }}</div> -->
		<div class="tnice7">
			<span v-show="!isNice">送祝福</span>
			<span v-show="isNice">{{ shareNum }}</span>
		</div>
		<div id="emjio" ref="emjio"></div>
	</div>
</template>

<script>
	import {
		uuid
	} from '@/utils/toolSet';
	export default {
		name: 'Nice',
		props: {
			shareNum: String
		},
		data() {
			return {
				zan: 0,
				scale: false,
				isNice: false,
				niceTimer: null,
				uuid: '',
				isShare: true,
				niceImage: false
			};
		},
		/* 创建前 */
		beforeCreate() {},
		/* 创建后 */
		created() {
			const THAT = this;
			THAT.uuid = localStorage.getItem('kwai-uuid') || uuid();
		},
		/* 挂载前 */
		beforeMount() {},
		/* 挂载后 */
		mounted() {
			const THAT = this;
			THAT.niceInter();
		},
		/* 内部方法 */
		methods: {
			niceInter() {
				const THAT = this;
				THAT.niceTimer = window.setInterval(function() {
					THAT.isNice = !THAT.isNice;
				}, 2000);
			},
			rdf(num) {
				return Math.random() > 0.5 ? num : -num;
			},
			touchStart() {
				this.scale = true;
			},
			touchEnd() {
				const THAT = this;
				let epsa = this.$refs.emjio;
				let that = this;
				let a = Math.floor(10 * Math.random());
				let div = document.createElement('div');
				div.setAttribute('class', 'psap');
				div.style.cssText = `background-position : -${(a * 60) / 7.5}vw 0;left: ${(70 - 60) / 2 / 7.5}vw`;
				epsa.appendChild(div);
				let rotate = Math.random() > 0.5 ? 30 : -30;
				div.animate(
					[{
							transform: 'matrix(0.1, 0, 0, 0.1, 0, -10)',
							opacity: 0
						},
						{
							transform: `matrix(.8, 0, 0, .8, 0, ${10 * Math.random() - 30}) rotate(${rotate}deg)`,
							opacity: 0.8
						},
						{
							transform: `matrix(1.3, 0, 0, 1.3, 0,${10 * Math.random() - 60}) rotate(${rotate}deg)`,
							opacity: 1
						},
						{
							transform: `matrix(1.8, 0, 0, 1.8, 0,${10 * Math.random() - 90}) rotate(${rotate}deg)`,
							opacity: 1
						},
						{
							transform: `matrix(1.5, 0, 0, 1.5,0, ${10 * Math.random() - 120}) rotate(${rotate}deg)`,
							opacity: 1
						},
						{
							transform: `matrix(1.1, 0, 0, 1.1, ${that.rdf(20)},${10 * Math.random() - 150} ) rotate(${rotate}deg)`,
							opacity: 0.8
						},
						{
							transform: `matrix(.8, 0, 0, .8, ${that.rdf(10)},${10 * Math.random() - 180} ) rotate(${rotate}deg)`,
							opacity: 0.2
						}
					],
					1700
				);
				this.scale = false;
				setTimeout(function() {
					epsa.removeChild(div);
				}, 1700);
				this.zan++;
				let shareForm = new FormData();
				shareForm.append('uuid', THAT.uuid);
				if (THAT.isShare) {
					THAT.isShare = false;
					THAT.axios({
						url: 'Photo/Share',
						method: 'POST',
						processData: false,
						mimeType: 'multipart/form-data',
						contentType: false,
						data: shareForm
					}).then(res => {
						THAT.isShare = true;
						localStorage.setItem('kwai-uuid', THAT.uuid);
						THAT.niceImage = true;
					}).catch(err => {
						THAT.isShare = true;
						console.log(err);
					});
				}
			}
		},
		/* 监听属性变化 */
		watch: {},
		/* 计算属性 */
		computed: {},
		/* 更新前 */
		beforeUpdate() {},
		/* 更新后 */
		updated() {},
		/* 卸载前 */
		beforedestory() {},
		/* 卸载后 */
		destroyed() {
			const THAT = this;
			window.clearInterval(THAT.niceTimer);
			THAT.niceTimer = null;
		}
	};
</script>
<style scoped lang="less">
	.niceBox {
		height: 128px;
		width: 100px;
		position: fixed;
		display: flex;
		bottom: 72px;
		right: 45px;
		z-index: 10;
		flex-direction: column;
		align-items: center;
		transform-style: preserve-3d;
		cursor: pointer;

		#emjio {
			width: 100%;
			height: 10px;
			position: absolute;
			bottom: 100px;
			left: 20px;
			z-index: 1;
			pointer-events: none;

			& :deep(.psap) {
				position: absolute;
				z-index: 1000;
				width: 60px;
				height: 60px;
				background: url('https://oss.eventnet.cn/H5/kwaiPlay/img/sprite2.png') no-repeat;
				background-size: 600px auto;
				top: 0;
				transform-origin: center center;
				transform: scale(0);
			}
		}

		.xnice {
			width: 100px;
			height: 100px;
			z-index: 10;
			position: relative;
			transition: all 0.08s linear;
			background-image: url('../assets/nice.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 10;

			&+div {
				background: rgba(255, 255, 255, 0.1);
				border-radius: 15px;
				padding: 2px 10px;
				font-size: 20px;
				color: #ffffff;
				margin-top: 10px;
				line-height: 30px;
				transform: translateZ(1px);

				&+div {
					margin-top: 10px;
				}
			}
		}

		.ynice {
			background-image: url('../assets/nice2.png');
		}

		.tnice7 {
			position: absolute;
			bottom: 0;
			left: -10px;
			z-index: 11;
			width: 120px !important;
			height: 44px !important;
			background: #fc591b !important;
			border: solid 2px #fff !important;
			border-radius: 22px !important;
			font-size: 26px !important;
			font-weight: bold !important;
			line-height: 26px !important;
			color: #fff !important;
			pointer-events: none;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>